import { DatePipe } from '@angular/common';
import { HttpParams, httpResource } from '@angular/common/http';
import { Component, effect, inject, signal, untracked } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { ListComponent } from '@components/list/list.component';
import { environment } from '@environment';
import { Case, ItemListResponse } from '@models';
import { AuthService, CaseService, NotificationService } from '@services';

@Component({
  selector: 'app-case-list',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
  imports: [
    MatListModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,

    FormsModule,
    DatePipe,
    RouterLink,

    ListComponent,
  ],
})
export class CaseListComponent {
  authService = inject(AuthService);
  caseService = inject(CaseService);
  notificationService = inject(NotificationService);
  route = inject(ActivatedRoute);
  router = inject(Router);

  page = signal(parseInt(this.route.snapshot.queryParams['page']) || 0);
  pageSize = signal(parseInt(this.route.snapshot.queryParams['pageSize']) || 10);
  q = signal(this.route.snapshot.queryParams['q'] as string || '');
  count = signal(0);

  cases = httpResource<ItemListResponse<Case>>(() => {
    const count = untracked(() => this.count() === 0 || this.page() === 0);
    const httpParams = new HttpParams()
      .set('skip', this.page() * this.pageSize())
      .set('take', this.pageSize())
      .set('count', count)
      .set('order', 'created:desc')
      .set('q', this.q());

    return `${environment.kinkoHost}/case/?${httpParams.toString()}`;
  });

  constructor() {
    effect(() => {
      if (!this.cases.hasValue() || !this.cases.value().count) {
        return;
      }

      this.count.set(this.cases.value().count);
    });

    this.route.queryParams.subscribe((params: Params) => {
      this.page.set(parseInt(params['page']) || 0);
      this.pageSize.set(parseInt(params['pageSize']) || 10);
      this.q.set(params['q'] as string || '');
    });
  }

  onPageEvent(event: PageEvent) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        page: event.pageIndex || undefined,
        pageSize: event.pageSize === 10 ? undefined : event.pageSize,
      },
      replaceUrl: true
    });
  }

  onSearchEvent(event: Event) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        q: (event.target as HTMLInputElement).value || undefined,
        page: undefined,
      },
      replaceUrl: true
    });
  }
}
